import type { ReactNode } from 'react';

/**
 * Carries this console's design tokens into the `@braidlabs/console` components.
 *
 * Two parts, and both are load-bearing.
 *
 * **The id** wins the specificity fight. `ensureStyles()` appends the OSS stylesheet to
 * `document.head` at mount, so it always lands *after* our bundle and wins any tie on source
 * order — including its own `.braid-console[data-theme='dark']` rules at (0,2,0). `#braid-theme
 * .braid-console` is (1,1,0) and outranks those outright.
 *
 * **The class** is the scope those tokens are declared on. Every `--bc-*` property — ours and the
 * package's own defaults — lives on `.braid-console`, and only `RegistryConsole` renders that
 * class itself. A lower-level component mounted directly, as `TopologyGraph` is, inherits nothing:
 * `var(--bc-bg)` resolves to an invalid value, and an SVG `fill` then falls back to its initial
 * value, **black**. The graph drew black boxes with black labels inside them — invisible rather
 * than merely wrong, which is why it survived a palette change without anyone noticing it had
 * never been themed at all.
 *
 * Nesting is harmless: `RegistryConsole` renders its own `.braid-console` inside this one and
 * re-declares the same values.
 */
export function ThemeBridge({ children }: { children: ReactNode }) {
  return (
    <div id="braid-theme">
      <div className="braid-console">{children}</div>
    </div>
  );
}
